<template>
	<div class="search">
		<div class="title">Søg</div>
		<div class="search-container">
			<input v-model="input" v-bind="{placeholder}" @input="update(input)"/>
			<span class="icon" v-html="require('@/assets/icons/search.svg')" />
		</div>
	</div>
</template>

<script>
import {debounce} from "lodash";

export default {
	data() {
		return {
			placeholder: "Søg",
			input: this.$route.query.search
		}
	},

	methods: {
		update: debounce(function(input) {
			this.$emit("update", {search: input || undefined});
		}, 500)
	}
};
</script>

<style lang="scss" scoped>
.search {

	@include res(mobile) {
		width: 100%;
	}

	input {
		width: 100%;
		border: none;
		min-height: 38px;
		outline: none;
		border-radius: 2px;
		padding-left: 7px;
		@include res(mobile) {
			border-radius: 20px;
			min-height: 30px;
		}

	}

	.search {
		
		@include res(mobile) {
			padding-right: 25px;
		}

		.search-container {
			display: flex;
			align-items: center;
			background-color: white;
			border-radius: 2px;
			padding: 0 10px;
			@include res(mobile) {
				min-height: 38px;
				width: 100%;
			}
			.icon {
				margin-left: 10px;
				@include res(mobile) {
					/deep/ svg {
						vertical-align: middle;
						width: 15px;
						height: 15px;
					}
				}
			}
		}
	}
	
	.title {
		font-weight: 300;
		margin-bottom: 5px;
		@include res(mobile) {
			display: none;
		}
	}
}
</style>
